import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import * as config from '../../config/app.config';
import { BaseService } from '../../services/base.service';
import { SharedService } from '../../services/shared.service';
import { HttpClient } from '@angular/common/http';
import { getLastValueSync, OccEndpointsService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CustomOrderHistory, OrderItem } from '../../model';
import { OLD_QUOTE_CODE, ORIGINAL_ORDER_CODE } from '../../const';
import { DataLayerService } from '../data-layer';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  b2bUnitID: any;
  updatedContact: any;
  orderDataForinlfuenza: any;
  userAccountData: any;
  public tabselected = new BehaviorSubject<any>(false);
  tabselected$ = this.tabselected.asObservable();
  public emails = new BehaviorSubject<any>(false);
  emails$ = this.emails.asObservable();
  updatedOrderDetails: any;
  public updatedStdOrderDetails = new BehaviorSubject<any>(false);
  updatedStdOrderDetails$ = this.updatedStdOrderDetails.asObservable();
  public userAccountDetails = new BehaviorSubject<any>(false);
  public userAccountDetails$ = this.userAccountDetails.asObservable();
  constructor(
    private readonly baseService: BaseService,
    private readonly sharedService: SharedService,
    private readonly dataLayerService: DataLayerService,
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected userFacade: UserAccountFacade
  ) {
    this.updatedContact = new Subject();
    this.updatedOrderDetails = new Subject();
  }

  updateContact(params, userId, cartId): void {
    this.baseService
      .post(
        config.USER_ACCOUNT +
          userId +
          '/saveOrderContact?cartId=' +
          cartId +
          '&fields=DEFAULT',
        params
      )
      .subscribe((res) => {
        if (res) {
          this.updatedContact.next(res);
        }
      });
  }
  getEmails(userId, b2bUnitID): void {
    this.emails.next(false);
    this.baseService
      .get(
        config.USER_ACCOUNT + userId + '/customerEmails?b2bUnitId=' + b2bUnitID
      )
      .subscribe((res) => {
        if (res) {
          this.emails.next(res);
        }
      });
  }
  updateOrder(userId, cartId, params): void {
    this.updatedStdOrderDetails.next(false);
    this.updatedOrderDetails.next(false);
    const url = this.occEndpointsService.buildUrl('placeNewOrder', {
      urlParams: {
        userId,
      },
      queryParams: {
        cartId,
      },
    });
    this.http.post(url, params).subscribe((res: OrderItem) => {
      if (res) {
        this.orderDataForinlfuenza = res;
        this.sharedService.setSessionStorage(
          'orderDataForinlfuenza',
          this.orderDataForinlfuenza
        );
        if (res?.cartType === 'INFLUENZA') {
          this.updatedOrderDetails.next(res);
        } else {
          this.updatedStdOrderDetails.next(res);
        }
      }
    });
  }

  editOrder(userId, cartId, params): void {
    this.updatedStdOrderDetails.next(false);
    this.updatedOrderDetails.next(false);
    const url = this.occEndpointsService.buildUrl('editOrder', {
      urlParams: {
        userId,
        orderCode:
          this.sharedService.getSessionStorage(ORIGINAL_ORDER_CODE) ?? '',
      },
      queryParams: {
        cartId,
      },
    });
    this.http.post(url, params).subscribe((res: CustomOrderHistory) => {
      if (res) {
        this.orderDataForinlfuenza = res.orders?.[0] || res;
        this.sharedService.setSessionStorage(
          'orderDataForinlfuenza',
          this.orderDataForinlfuenza
        );
        this.updatedOrderDetails.next(res);
      }
    });
  }

  placeExpressDeliveryOrder(userId, cartId, params) {
    this.updatedStdOrderDetails.next(false);
    this.updatedOrderDetails.next(false);
    const url = this.occEndpointsService.buildUrl('placeExpressOrder', {
      urlParams: {
        userId,
      },
      queryParams: {
        cartId,
      },
    });
    this.http.post(url, params).subscribe((res: OrderItem) => {
      if (res) {
        this.orderDataForinlfuenza = res;
        this.sharedService.setSessionStorage(
          'orderDataForinlfuenza',
          this.orderDataForinlfuenza
        );
        this.updatedStdOrderDetails.next(res);
      }
    });
  }

  tabSelection(params): void {
    this.tabselected.next(params);
  }

  createQuote(payload: {
    purchaseOrderNumber: string;
    seasonId: string;
  }): void {
    const userId = getLastValueSync(this.userFacade.get()).uid;
    const url = this.occEndpointsService.buildUrl('createQuote', {
      urlParams: {
        userId,
      },
      queryParams: {
        oldQuoteCode:
          this.sharedService.getSessionStorage(OLD_QUOTE_CODE) ?? '',
        purchaseOrderNumber: payload.purchaseOrderNumber,
        seasonId: payload.seasonId,
        isEmulated: this.sharedService.getLocalStorage('asmEnabled'),
      },
    });
    this.http.post(url, {}).subscribe((res) => {
      this.sharedService.setSessionStorage('orderDataForinlfuenza', res);
      this.updatedOrderDetails.next(res);
    });
  }

  editQuote(oldQuoteCode, cartId: string, params): void {
    this.updatedStdOrderDetails.next(false);
    this.updatedOrderDetails.next(false);
    const userId = getLastValueSync(this.userFacade.get()).uid;
    const url = this.occEndpointsService.buildUrl('editQuote', {
      urlParams: {
        userId,
        oldQuoteCode,
      },
      queryParams: {
        cartId,
      },
    });
    this.http.post(url, params).subscribe((res: OrderItem) => {
      if (res) {
        this.orderDataForinlfuenza = res;
        this.sharedService.setSessionStorage(
          'orderDataForinlfuenza',
          this.orderDataForinlfuenza
        );
      }
    });
  }

  public getUserAccountDataFromDb(userId): void {
    this.userAccountData = new Subject<any>();
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/`, { fields: 'FULL' })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.userAccountData.next({ res });
        }
      });
  }
  public getUserAccountDetailsDataFromDb(userId, accountId): void {
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${accountId}`, {
        fields: 'FULL',
      })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.userAccountDetails.next({ res });
        }
      });
  }
}
